import RouteTemplate from "ember-route-template";
import ProxyviewsProviderDetail from "../components/proxyviews-provider-detail";

export default RouteTemplate(
  <template><ProxyviewsProviderDetail @model={{@model}} /></template>
);
